import { Grid } from "@mui/material";
import {
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  required,
  useSimpleFormIteratorItem,
} from "react-admin";
import { useWatch } from "react-hook-form";
import EmployeeInput from "server/components/Fields/EmployeeInput";
import { employeeRequests } from "api/employeeApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";

export const SupervisorIteratorItem = () => {
  const { index } = useSimpleFormIteratorItem();
  const supervisors = useWatch({ name: "supervisors" });

  const excludeIds =
    supervisors
      ?.filter((_, i) => i !== index)
      ?.map(s => s?.employeeId)
      ?.filter(Boolean) ?? [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <EmployeeInput
          source="employeeId"
          label="Научен ръководител"
          reference={employeeRequests.getProfessorsSelect()}
          filters={excludeIds.length ? { ExcludeIds: excludeIds } : {}}
          validate={required("Задължително")}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

const TopicAndSupervisorsSection = () => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <TextInput
        source="topic"
        label="Тема на дисертацията"
        validate={required("Задължително")}
        multiline
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <TextInput
        source="orderNumber"
        label="Номер на заповед за зачисляване"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <CustomDateInput
        source="orderDate"
        label="Дата на заповед за зачисляване"
        validate={required("Задължително")}
        noTime
        fullWidth
        required
      />
    </Grid>
    <Grid item xs={12}>
      <ArrayInput
        source="supervisors"
        label="Научни ръководители"
        validate={required("Задължително")}
      >
        <SimpleFormIterator inline={false} disableClear>
          <SupervisorIteratorItem />
        </SimpleFormIterator>
      </ArrayInput>
    </Grid>
  </Grid>
);

export default TopicAndSupervisorsSection;
